import { render, staticRenderFns } from "./OrdersInformation.vue?vue&type=template&id=ec781ef8&"
import script from "./OrdersInformation.vue?vue&type=script&lang=js&"
export * from "./OrdersInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrdersInformation.vue?vue&type=style&index=0&id=ec781ef8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports